import React from "react"
import { Stack, Typography } from "@mui/material"
import imgNewsletter from "assets/images/newsletters/newsletter_mar_26.jpg"
import InfoCard from "components/controls/InfoCard"

const Newsletter = () => {
  return (
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <InfoCard title="NEWSLETTER">
        <Stack spacing={1}>
          <img
            alt="Newsletter"
            height="100%"
            src={imgNewsletter}
            width="100%"
          />
        </Stack>
      </InfoCard>
    </Stack>
  )
}

export default Newsletter
